module.exports = __webpack_public_path__ + "static/media/country_pe.d3b20df3.webp";